import api from "@/services/api";

const SRCookies = {

    set(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },

    get(cname) {

        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },

    getCISession(){
        var value = "; " + document.cookie;
        let cookiePrefix = api.clientData('is_tools_env') ? 'tools_' : '';
        let cookieName = `${api.clientData("domain.slug")}_session`;
        let cookieSuffix = (api.clientData("environment") !== 'production') ? `_${api.clientData("environment")}` : '';
        
        cookieName = cookiePrefix + cookieName + cookieSuffix;
        var parts = value.split(`; ${cookieName}=`);
        if (parts.length == 2) return parts.pop().split(";").shift();
    },

    session(){

        let id = this.getCISession();
        if(!id) return null;
        return this.parseSerializedPhp(decodeURIComponent(id))
    },

    isMobileSession(){
        let session = this.session();
        
        return (session && session.is_mobile_app === '1') || this.isSRMobileSession();
    },

    isSRMobileSession() {
        const mobileSession = this.get('sr_mobile_session');
        return !!mobileSession;
    },

    parseSerializedPhp(str) {
        switch (str[0]) {
            case 'a':
                var retArray = {};
                var matches = str.match(/a:(\d+):(\{.*\})/);
                var subElems = matches[2].match(/((s:\d+:"[^"]*";)|([b|i|f]:\d+))/g);
                for (var i = 0; i < subElems.length; i++) {
                    var key = this.parseSerializedPhp(subElems[i]);
                    retArray[key] = this.parseSerializedPhp(subElems[i + 1]);
                    i++;
                }
                return (retArray);

            case 's':
                return (str.split('"')[1]);

            case 'i':
                return (parseInt(str.match(/\d+/)));

            case 'b':
                return (parseInt(str.match(/\d+/)) ? true : false); // eslint-disable-line no-unneeded-ternary
        }
        return (null);
    }

}

export default SRCookies;
